<template>
  <div class="cl:hidden">
    <div class="flex items-center gap-8">
      <a
        v-if="socialLink"
        :href="socialLink.url"
        target="_blank"
        class="text-primary text-xl md:text-5xl"
        aria-label="social media link"
      >
        <i :class="socialLink.iconFontawsome"></i>
      </a>

      <button
        @click="isOpen = !isOpen"
        class="text-primary relative z-50 text-xl md:text-5xl"
        :aria-expanded="isOpen"
        aria-label="Menu"
      >
        <Transition name="icon-fade" mode="out-in">
          <i v-if="!isOpen" key="menu" class="fa-solid fa-bars"></i>
          <img
            v-else
            key="close"
            class="h-[1em] w-[1em] object-contain"
            src="/web/assets/header-Cross.svg"
            alt="Menü schliessen"
          />
        </Transition>
      </button>
    </div>

    <Transition name="slide-down">
      <div
        v-if="isOpen"
        class="z-5 border-primary fixed left-0 right-0 top-[calc(4.25rem+8px)] border-[6px] border-t-0 bg-white md:top-[calc(8rem+8px)]"
      >
        <div class="flex flex-col gap-8 px-8 py-12">
          <nav class="flex flex-col gap-8">
            <a
              v-for="(navLink, index) in navLinks"
              :key="index"
              :href="navLink.url"
              :target="navLink.target"
              class="px-4 py-2 text-[2rem] font-light"
            >
              {{ navLink.linkText || navLink }}
            </a>
          </nav>

          <div class="flex flex-col items-start gap-4">
            <btn
              v-if="buttonTwo"
              :text="buttonTwo.linkText"
              type="primary-negative"
              :url="buttonTwo.url"
              :target="buttonTwo.target"
            />
            <btn
              v-if="buttonOne"
              :text="buttonOne.linkText"
              type="secondary-negative"
              :url="buttonOne.url"
              :target="buttonOne.target"
            />
          </div>
        </div>
      </div>
    </Transition>
  </div>
</template>

<script setup lang="ts">
import { inject, computed, onMounted, type Ref } from 'vue';
import btn from './button.vue';

interface NavLink {
  url: string;
  linkText?: string;
  target: string;
}

interface ButtonLink {
  url: string;
  linkText: string;
  target: string;
}

interface SocialLink {
  url: string;
  iconFontawsome: string;
}

const props = defineProps<{
  navLinks: NavLink[];
  buttonOne?: ButtonLink | null;
  buttonTwo?: ButtonLink | null;
  socialLink?: SocialLink | null;
}>();

// Inject menu state from ScrollingHeader
const menuState = inject<{
  isMenuOpen: Ref<boolean>;
  setMenuOpen: (value: boolean) => void;
}>('menuState');

const isOpen = computed({
  get: () => menuState?.isMenuOpen.value ?? false,
  set: (value: boolean) => {
    menuState?.setMenuOpen(value);
  },
});
</script>

<style scoped lang="scss">
.slide-down-enter-active {
  animation: slideDown 0.4s ease-out forwards;
}

.slide-down-leave-active {
  animation: slideUp 0.3s ease-in forwards;
}

@keyframes slideDown {
  from {
    clip-path: inset(0 0 100% 0);
  }
  to {
    clip-path: inset(0 0 0 0);
  }
}

@keyframes slideUp {
  from {
    clip-path: inset(0 0 0 0);
  }
  to {
    clip-path: inset(0 0 100% 0);
  }
}

.icon-fade-enter-active,
.icon-fade-leave-active {
  transition: opacity 0.1s ease;
}

.icon-fade-enter-from,
.icon-fade-leave-to {
  opacity: 0;
}
</style>
